import { useContext } from "react";
import { useSelector } from "react-redux";
import { ThemeContext } from "../common/themeContext";
import { isFeatureComingSoonMessage } from "../common/apiResponse";
import { isHealthcareBrand } from "../common/permissions";

export const useHealthcareCampaignComingSoon = (apiMessage = "") => {
  const { brandId } = useContext(ThemeContext);
  const profileState = useSelector((state) => state?.getAdminProfile);

  if (!isHealthcareBrand(brandId)) {
    return false;
  }

  return (
    Boolean(profileState?.comingSoon) ||
    isFeatureComingSoonMessage(profileState?.message) ||
    isFeatureComingSoonMessage(apiMessage)
  );
};
